import Chart from './Chart.container';

export default Chart;
